import { gql } from 'graphql.macro';

export const setupVismaCodingIdsTemplate = gql`
    mutation setupVismaCodingIds($labId: MongoDbObjectId!) {
        setupVismaCodingIds(labId: $labId) {
            unitId
            noVatCodingId
            vatCodingId
        }
    }
`;
